export const COMPANY = {
  name: "Master Business Consultoria Contábil",
  short: "Master Business",
  phone: "(62) 3626-6380",
  phoneRaw: "+556236266380",
  whatsapp: "5562362663800",
  whatsappLink: "https://wa.me/556236266380?text=Olá!%20Gostaria%20de%20falar%20com%20um%20especialista%20da%20Master%20Business.",
  email: "contabilidade@masterbusiness.cnt.br",
  address: {
    street: "Rua 104, nº 416, Quadra F 18, Lote 58",
    neighborhood: "Setor Sul",
    city: "Goiânia - GO",
    zip: "CEP: 74.083-300",
  },
  mapsEmbed:
    "https://www.google.com/maps?q=Rua+104,+416,+Setor+Sul,+Goi%C3%A2nia+-+GO,+74083-300&output=embed",
  logoHorizontal:
    "https://customer-assets.emergentagent.com/job_business-contabil/artifacts/pdxisxbw_Logo%20Master%20Bussiness2.png",
  logoVertical:
    "https://customer-assets.emergentagent.com/job_business-contabil/artifacts/08p8t5z4_Logo%20Master%20Bussiness.png",
};

export const NAV_ITEMS = [
  { id: "home", label: "Início" },
  { id: "sobre", label: "Sobre Nós" },
  { id: "servicos", label: "Serviços" },
  { id: "diferenciais", label: "Diferenciais" },
  { id: "contatos", label: "Contatos" },
];

export const SERVICES = [
  {
    icon: "BookOpenCheck",
    title: "Escrituração Contábil",
    desc: "Registro completo, preciso e em conformidade legal de todas as operações da sua empresa, garantindo balanços e demonstrativos confiáveis.",
  },
  {
    icon: "Users",
    title: "Departamento Pessoal",
    desc: "Gestão completa de folha de pagamento, admissões, rescisões, férias, eSocial e obrigações trabalhistas com total segurança.",
  },
  {
    icon: "FileSpreadsheet",
    title: "Escrita Fiscal",
    desc: "Apuração de tributos, escrituração de notas fiscais e cumprimento de obrigações acessórias municipais, estaduais e federais.",
  },
  {
    icon: "User",
    title: "Pessoas Físicas",
    desc: "Declaração de Imposto de Renda, planejamento tributário pessoal e regularização patrimonial com discrição e expertise.",
  },
  {
    icon: "Scale",
    title: "Paralegal",
    desc: "Suporte em rotinas societárias, abertura, alteração e baixa de empresas, além de assessoria em obrigações junto a órgãos públicos.",
  },
  {
    icon: "Gavel",
    title: "Perícia Contábil",
    desc: "Laudos técnicos, pareceres e assistência em processos judiciais e extrajudiciais com profissionais qualificados e imparciais.",
  },
  {
    icon: "Landmark",
    title: "Contabilidade Pública",
    desc: "Atendimento especializado a entes e órgãos públicos com aplicação rigorosa das normas brasileiras de contabilidade aplicadas ao setor.",
  },
];

export const DIFFERENTIALS = [
  {
    icon: "Award",
    title: "Mais de 8 anos de experiência",
    desc: "Desde 2017 atuando com seriedade e compromisso, construindo relações de longo prazo com nossos clientes.",
  },
  {
    icon: "GraduationCap",
    title: "Especialização técnica",
    desc: "Equipe registrada no CRC com domínio em perícia judicial, contabilidade pública e eleitoral — serviços que poucos escritórios oferecem.",
  },
  {
    icon: "Gavel",
    title: "Perito-Contador Judicial",
    desc: "Cadastrado no Banco de Peritos do TJGO, com experiência comprovada em laudos periciais e atuação em processos judiciais complexos.",
  },
  {
    icon: "Heart",
    title: "Atendimento personalizado",
    desc: "Soluções adaptadas à realidade de cada cliente, com acompanhamento próximo e comunicação clara em todas as etapas.",
  },
  {
    icon: "ShieldCheck",
    title: "Conformidade e segurança",
    desc: "Monitoramento contínuo da legislação fiscal, contábil e trabalhista para manter sua empresa sempre regularizada.",
  },
  {
    icon: "Clock",
    title: "Comprometimento com prazos",
    desc: "Cumprimento rigoroso dos prazos legais e judiciais, com transparência e responsabilidade em cada entrega.",
  },
];

export const VALUES = [
  {
    icon: "Target",
    title: "Missão",
    desc: "Oferecer soluções contábeis estratégicas que impulsionem o crescimento sustentável dos nossos clientes com excelência, ética e proximidade.",
  },
  {
    icon: "Eye",
    title: "Visão",
    desc: "Ser referência em consultoria contábil em Goiás, reconhecida pela qualidade, inovação e impacto positivo nos negócios que atendemos.",
  },
  {
    icon: "Gem",
    title: "Valores",
    desc: "Ética, transparência, compromisso, excelência técnica, inovação e respeito incondicional ao cliente.",
  },
];

export const STATS = [
  { value: 8, suffix: "+", label: "Anos de Atuação" },
  { value: 4, suffix: "", label: "Segmentos Atendidos" },
  { value: 3, suffix: "", label: "Especialidades Únicas" },
];

export const PARTNERS = [
  { name: "AC Áudio", src: "/parceiros/ac-audio.jpeg" },
  { name: "Empório Vieira", src: "/parceiros/emporio-vieira.jpeg" },
  { name: "Geison Lima", src: "/parceiros/geison-lima.jpeg" },
  { name: "GoWinner", src: "/parceiros/gowinner.jpg" },
  { name: "JP", src: "/parceiros/jp.jpg" },
  { name: "JSantos", src: "/parceiros/jsantos.png" },
  { name: "Logo Parceiro", src: "/parceiros/logo-extra.png" },
  { name: "MyPet", src: "/parceiros/mypet.jpeg" },
  { name: "Personnalité", src: "/parceiros/personnalite.jpeg" },
  { name: "Premium Sorveteria", src: "/parceiros/premium-sorveteria.jpeg" },
  { name: "Rei Gás", src: "/parceiros/rei-gas.jpeg" },
  { name: "Tambaqui do Cerrado", src: "/parceiros/tambaqui.jpeg" },
];
